import { Skeleton, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTheme } from '@mui/material/styles';
import styles from './styles';

const HandsetTitle = ({
  price,
  brand,
  model,
  loadingHandset,
  handsetJourney,
  upfrontPrice,
  phoneCost,
}) => {
  const theme = useTheme();

  return !loadingHandset ? (
    <Stack>
      <Typography variant='overline' sx={styles(theme).brandName}>
        {brand}
      </Typography>
      <Typography variant='h2' sx={styles(theme).brandModel}>
        {model}
      </Typography>

      {handsetJourney ? (
        <Typography variant='avatarLetter' sx={styles(theme).brandPriceText}>
          {upfrontPrice ? '' : 'From'}
          {!upfrontPrice ? (
            <Typography variant='h3' sx={styles(theme).brandPrice}>
              &nbsp; {price}
            </Typography>
          ) : (
            <Typography variant='h3' sx={styles(theme).brandPrice}>
              {phoneCost === '0.00' ? 'Free' : `€${phoneCost}`}
            </Typography>
          )}
        </Typography>
      ) : (
        <Typography variant='h3' sx={styles(theme).brandPrice}>
          {price}
        </Typography>
      )}
    </Stack>
  ) : (
    <Stack>
      <Skeleton width='20%' />
      <Skeleton width='40%' />
      <Skeleton width='20%' />
    </Stack>
  );
};

export default HandsetTitle;
